import { Page, PageFace, Panel, PanelFace } from 'ui/components'

import { ReportBreadcrumbs } from '../../components'
import { Actions, Filter, ReportTable } from './components'
import { DocumentStatusReportContextProvider } from './context/contextProvider'

const DocumentStatusReport = () => (
  <DocumentStatusReportContextProvider>
    <Page face={PageFace.PRIMARY} title={<ReportBreadcrumbs title="Document Status Report" />} actions={<Actions />}>
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <ReportTable />
      </Panel>
    </Page>
  </DocumentStatusReportContextProvider>
)

export default DocumentStatusReport
